/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { status } from 'constants/general';

const initialState = {
  context: '',
  routeHistory: [],
  toasts: [],
  countries: {
    status: status.SHOULD_CALL_API,
    data: [],
  },
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setContext(state, action) {
      state.context = action.payload;
    },
    setRouteHistory(state, action) {
      state.routeHistory = action.payload;
    },
    addToast(state, action) {
      state.toasts = [...state.toasts, action.payload];
    },
    deleteToast(state, action) {
      const updatedToasts = state.toasts.filter(toast => toast.id !== action.payload);
      state.toasts = updatedToasts;
    },
    fetchCountries(state) {
      state.countries = {
        status: status.FETCHING,
        data: [],
      };
    },
    fetchCountriesSuccess(state, action) {
      state.countries = {
        status: status.SUCCESS,
        data: action.payload,
      };
    },
    fetchCountriesFail(state) {
      state.countries = {
        status: status.FAIL,
      };
    },
  },
});

export const {
  setContext,
  setRouteHistory,
  addToast,
  deleteToast,
  fetchCountries,
  fetchCountriesSuccess,
  fetchCountriesFail,
} = commonSlice.actions;

export default commonSlice.reducer;
